import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb0cf9f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "reschedule-banner",
  class: "d-flex justify-content-center mx-auto"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row mx-0 my-1 w-100\" data-v-fb0cf9f4><div class=\"col-2 pl-1 pr-0 d-flex justify-content-center\" data-v-fb0cf9f4><img src=\"https://dr4y4dqumhrhn.cloudfront.net/soma_calendar_new.png\" data-v-fb0cf9f4></div><div class=\"col-8 px-0 d-flex flex-column justify-content-center\" data-v-fb0cf9f4><div id=\"reschedule-msg-bg\" class=\"text-center\" data-v-fb0cf9f4>Flexi Reschedule</div><div id=\"reschedule-msg-sm\" class=\"text-center\" data-v-fb0cf9f4>This booking is under Flexi Reschedule Policy.</div></div><div class=\"col-2 px-0 d-flex justify-content-center\" data-v-fb0cf9f4><img src=\"https://dr4y4dqumhrhn.cloudfront.net/green_tick_new.png\" data-v-fb0cf9f4></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "carouselbar mx-auto"
}
const _hoisted_5 = {
  class: "carousel-inner",
  id: "carouselInner"
}
const _hoisted_6 = ["data-interval"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "video-play-btn" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 5v14l11-7z" })
], -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-target=\"#homeCarouse\" data-slide=\"prev\" data-v-fb0cf9f4><span class=\"visually-hidden\" data-v-fb0cf9f4>Previous</span><svg class=\"ccarroricon\" data-v-fb0cf9f4><use xlink:href=\"#chevron-left-angle\" data-v-fb0cf9f4></use></svg></button><button class=\"carousel-control-next\" type=\"button\" data-target=\"#homeCarouse\" data-slide=\"next\" data-v-fb0cf9f4><span class=\"visually-hidden\" data-v-fb0cf9f4>Next</span><svg class=\"ccarroricon\" data-v-fb0cf9f4><use xlink:href=\"#chevron-right\" data-v-fb0cf9f4></use></svg></button>", 2)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "py-4 w-100" }
const _hoisted_16 = { class: "row mx-0 w-100 mt-2" }
const _hoisted_17 = { class: "col-12 px-0" }
const _hoisted_18 = { id: "select-outlet-outer-container" }
const _hoisted_19 = {
  id: "select-outlet-container",
  class: "d-flex"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/outlet_light.png" }, null, -1 /* HOISTED */))
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "row mx-0 w-100 mt-2"
}
const _hoisted_23 = { class: "col-12 px-0" }
const _hoisted_24 = { id: "address-outer-container" }
const _hoisted_25 = {
  id: "address-container",
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m21.97,10.99h0c0-2.38-.94-4.67-2.63-6.35-1.69-1.7-3.94-2.64-6.33-2.64-2.74,0-5.29,1.22-7.03,3.42-1.26,1.59-1.95,3.56-1.94,5.59v1.49c0,.76-.6,1.51-1.6,1.51-.17,0-.32.11-.37.27-.19.62.57,2,1.65,3.09.68.7,1.48,1.27,2.36,1.71-.24,1.36.67,2.65,2.03,2.89.14.02.28.04.43.04,1.19,0,2.21-.83,2.44-2h2.09c.28,1.41,1.74,2.38,3.31,1.85.68-.23,1.22-.77,1.47-1.45.23-.65.2-1.28-.01-1.83.55-.35,1.06-.77,1.52-1.23,1.69-1.69,2.63-3.97,2.62-6.36Zm-8.96,8.02h-2.04c-.23-1.17-1.25-2.01-2.44-2.01-.85,0-1.64.43-2.1,1.14v.02c-.75-.39-1.43-.89-2.01-1.49-.7-.71-1.08-1.36-1.26-1.77.46-.11.87-.35,1.19-.7.43-.46.67-1.08.66-1.71v-1.49c0-1.77.59-3.5,1.67-4.9,1.55-2,3.85-3.11,6.31-3.11,2.12,0,4.12.83,5.63,2.35,1.5,1.5,2.34,3.53,2.34,5.65,0,2.14-.83,4.14-2.33,5.66-1.47,1.48-3.49,2.36-5.63,2.36Z" }, null, -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m12,9c0-.55-.45-1-1-1s-1,.45-1,1,.45,1,1,1,1-.45,1-1Z" }, null, -1 /* HOISTED */))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m17.37,12.04c-.07-.03-.14-.05-.21-.05h-.01c-.19,0-.36.11-.44.28-.49,1.05-1.54,1.71-2.7,1.72-1.16,0-2.21-.67-2.7-1.72-.08-.17-.26-.28-.45-.28-.27,0-.5.22-.5.5,0,.07.02.14.05.21.66,1.4,2.06,2.29,3.61,2.29,1.55,0,2.95-.9,3.61-2.29.12-.25,0-.54-.24-.66Z" }, null, -1 /* HOISTED */))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m16.99,8c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1h0c0-.55-.45-1-1-1Z" }, null, -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "ml-2 address-text" }
const _hoisted_33 = { class: "row mx-0 w-100 mt-2" }
const _hoisted_34 = { class: "col-4 pl-0 pr-1" }
const _hoisted_35 = { id: "session-outer-container" }
const _hoisted_36 = {
  id: "session-container",
  class: "row mx-0 d-flex justify-content-center align-items-center"
}
const _hoisted_37 = {
  id: "minutes-display",
  class: "col-8 px-0 d-flex justify-content-center"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/duration_light.png" }, null, -1 /* HOISTED */))
const _hoisted_39 = { class: "d-flex flex-column justify-content-center align-items-center ml-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "minutes" }, "mins", -1 /* HOISTED */))
const _hoisted_41 = { class: "col-8 px-0" }
const _hoisted_42 = { id: "date-outer-container" }
const _hoisted_43 = {
  id: "date-container",
  class: "d-flex justify-content-end px-2"
}
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "row mx-0 w-100 mt-2" }
const _hoisted_46 = { class: "col-3 pl-0 pr-1" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "therapist-gender-container",
  class: "row mx-0 d-flex justify-content-center align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "therapist-gender-female",
    class: "px-0",
    src: "https://dr4y4dqumhrhn.cloudfront.net/therapist_female.png"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    id: "therapist-gender-male",
    class: "px-0",
    src: "https://dr4y4dqumhrhn.cloudfront.net/therapist_male.png"
  })
], -1 /* HOISTED */))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "therapist-gender-container",
  class: "row mx-0 d-flex justify-content-center align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "therapist-gender-back",
    class: "px-0",
    src: "https://dr4y4dqumhrhn.cloudfront.net/therapist_back.png"
  })
], -1 /* HOISTED */))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "col-9 px-0" }
const _hoisted_52 = { id: "pax-outer-container" }
const _hoisted_53 = {
  id: "pax-container-auto",
  class: "row mx-0 d-flex justify-content-center align-items-center"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "label-any-therapist",
  class: "col-6 px-0 d-flex align-items-center"
}, "Any Therapist Gender (More Slots)", -1 /* HOISTED */))
const _hoisted_55 = {
  id: "pax-display",
  class: "col-3 px-0 mx-1 d-flex justify-content-center"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/pax_light.png" }, null, -1 /* HOISTED */))
const _hoisted_57 = { class: "ml-2 d-flex align-items-center" }
const _hoisted_58 = {
  id: "pax-container-specific",
  class: "row mx-0 d-flex justify-content-center align-items-center"
}
const _hoisted_59 = { class: "row mx-0 d-flex justify-content-center align-items-center" }
const _hoisted_60 = {
  id: "female-pax-display",
  class: "col-6 px-0 mx-1 d-flex justify-content-center"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/girl%20brown.png" }, null, -1 /* HOISTED */))
const _hoisted_62 = { class: "ml-2 d-flex align-items-center" }
const _hoisted_63 = { class: "row mx-0 d-flex justify-content-center align-items-center" }
const _hoisted_64 = {
  id: "male-pax-display",
  class: "col-6 px-0 mx-1 d-flex justify-content-center"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/man%20brown.png" }, null, -1 /* HOISTED */))
const _hoisted_66 = { class: "ml-2 d-flex align-items-center" }
const _hoisted_67 = { class: "row mx-0 w-100 mt-2" }
const _hoisted_68 = { class: "col-12 px-0" }
const _hoisted_69 = { id: "rating-outer-container" }
const _hoisted_70 = { class: "row mx-0" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "label-rating",
  class: "col-3 pl-1 pr-0 d-flex align-items-center"
}, [
  /*#__PURE__*/_createTextVNode("Therapist"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Rating")
], -1 /* HOISTED */))
const _hoisted_72 = {
  id: "rating-container",
  class: "col-9 px-0 d-flex justify-content-center align-items-center"
}
const _hoisted_73 = { class: "row mx-0 w-100" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/star_brown.png" }, null, -1 /* HOISTED */))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ANY", -1 /* HOISTED */))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/star_brown.png" }, null, -1 /* HOISTED */))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "4+", -1 /* HOISTED */))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/star_brown.png" }, null, -1 /* HOISTED */))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "5", -1 /* HOISTED */))
const _hoisted_80 = { class: "row mx-0 w-100 mt-2" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "view-time-now",
  class: "px-0",
  src: "https://dr4y4dqumhrhn.cloudfront.net/view_time_now.png"
}, null, -1 /* HOISTED */))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 1,
  id: "therapist-rating-banner",
  class: "row mx-0 w-100 mt-2 p-3"
}
const _hoisted_84 = /*#__PURE__*/_createStaticVNode("<div class=\"col-3 px-0\" style=\"margin-top:-40px;margin-bottom:-40px;margin-left:-30px;margin-right:30px;\" data-v-fb0cf9f4><img src=\"https://dr4y4dqumhrhn.cloudfront.net/som_som_star_gif.gif\" style=\"max-width:140px;width:140px;\" data-v-fb0cf9f4></div><div class=\"col-9 pl-2 pr-0 d-flex flex-column\" data-v-fb0cf9f4><span style=\"font-family:&#39;Minecraft&#39;, sans-serif;font-size:18px;font-weight:bold;\" data-v-fb0cf9f4>COMING SOON</span><span style=\"font-size:12px;\" data-v-fb0cf9f4>We&#39;re still identifying</span><span style=\"font-size:12px;\" data-v-fb0cf9f4>our 4-5 Stars Therapists.</span><span style=\"font-size:12px;\" data-v-fb0cf9f4>Choose ANY therapist to continue.</span></div>", 2)
const _hoisted_86 = [
  _hoisted_84
]
const _hoisted_87 = {
  key: 2,
  class: "row mx-0 w-100 mt-2"
}
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "d-flex justify-content-center time" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "more-discount",
  class: "col-8"
}, " MORE DISCOUNT! ", -1 /* HOISTED */))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "img-nearby-outlet",
  src: "https://dr4y4dqumhrhn.cloudfront.net/soma_to_soma.webp"
}, null, -1 /* HOISTED */))
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]
const _hoisted_93 = {
  key: 4,
  id: "more-discount-row",
  class: "row mx-0 w-100 mt-4"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "more-discount",
  class: "col-8"
}, " MORE DISCOUNT! ", -1 /* HOISTED */))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "img-nearby-outlet",
  src: "https://dr4y4dqumhrhn.cloudfront.net/soma_to_soma.webp"
}, null, -1 /* HOISTED */))
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = { class: "row mx-0 w-100" }
const _hoisted_98 = { class: "suggested-outlet-row px-0 my-2" }
const _hoisted_99 = {
  key: 0,
  class: "nearby-outlet-title col-12 px-3"
}
const _hoisted_100 = { class: "col-6 flex flex-column pl-4 pr-0" }
const _hoisted_101 = { class: "shop-full-name" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "col-6 pl-0 pr-4 row mx-0" }
const _hoisted_104 = { class: "col-5 px-0 flex flex-column justify-content-center align-items-center" }
const _hoisted_105 = { class: "distant" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "distant-label flex justify-content-center" }, " KM Away ", -1 /* HOISTED */))
const _hoisted_107 = { class: "col-7 px-0 flex justify-content-center" }
const _hoisted_108 = { class: "flex flex-column" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center up-to-label" }, "UP TO", -1 /* HOISTED */))
const _hoisted_110 = { class: "flex justify-content-center highest-discount" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "highest-discount-label flex flex-column justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "%"),
  /*#__PURE__*/_createElementVNode("span", null, "off")
], -1 /* HOISTED */))
const _hoisted_112 = { class: "row mx-0 w-100" }
const _hoisted_113 = { class: "suggested-outlet-row px-0 my-2" }
const _hoisted_114 = {
  key: 0,
  class: "nearby-outlet-title col-12 px-3 flex justify-content-between align-items-center"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Other Brands", -1 /* HOISTED */))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/broccoli_partner.png" }, null, -1 /* HOISTED */))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/hl_purple.png" }, null, -1 /* HOISTED */))
const _hoisted_118 = [
  _hoisted_115,
  _hoisted_116,
  _hoisted_117
]
const _hoisted_119 = { class: "col-6 flex flex-column pl-4 pr-0" }
const _hoisted_120 = { class: "shop-full-name" }
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { class: "col-6 pl-0 pr-4 row mx-0" }
const _hoisted_123 = { class: "col-5 px-0 flex flex-column justify-content-center align-items-center" }
const _hoisted_124 = { class: "distant" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "distant-label flex justify-content-center" }, " KM Away ", -1 /* HOISTED */))
const _hoisted_126 = { class: "col-7 px-0 flex justify-content-center" }
const _hoisted_127 = { class: "flex flex-column" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center up-to-label" }, "UP TO", -1 /* HOISTED */))
const _hoisted_129 = { class: "flex justify-content-center highest-discount" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "highest-discount-label flex flex-column justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "%"),
  /*#__PURE__*/_createElementVNode("span", null, "off")
], -1 /* HOISTED */))
const _hoisted_131 = {
  key: 7,
  class: "row mx-0 w-100"
}
const _hoisted_132 = { class: "suggested-outlet-row px-0 my-2" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "same-outlet-title-nd",
  class: "col-12 px-3"
}, "Same Outlet | New Date", -1 /* HOISTED */))
const _hoisted_134 = { class: "same-outlet-content row mx-0 py-2" }
const _hoisted_135 = { class: "col-6 flex flex-column pl-4 pr-0" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "shop-full-name" }, "Next Day", -1 /* HOISTED */))
const _hoisted_137 = { class: "shop-full-name" }
const _hoisted_138 = { class: "col-6 pl-0 pr-4 row mx-0" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, null, -1 /* HOISTED */))
const _hoisted_140 = { class: "col-7 px-0 flex justify-content-center" }
const _hoisted_141 = { class: "flex flex-column" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center up-to-label" }, "UP TO", -1 /* HOISTED */))
const _hoisted_143 = { class: "flex justify-content-center highest-discount" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "highest-discount-label flex flex-column justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "%"),
  /*#__PURE__*/_createElementVNode("span", null, "off")
], -1 /* HOISTED */))
const _hoisted_145 = {
  key: 8,
  class: "row mx-0 w-100"
}
const _hoisted_146 = { class: "suggested-outlet-row px-0 my-2" }
const _hoisted_147 = {
  key: 0,
  id: "same-outlet-title-nw",
  class: "col-12 px-3"
}
const _hoisted_148 = { class: "col-6 flex flex-column pl-4 pr-0" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "shop-full-name" }, "Next Week", -1 /* HOISTED */))
const _hoisted_150 = { class: "shop-full-name" }
const _hoisted_151 = { class: "col-6 pl-0 pr-4 row mx-0" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, null, -1 /* HOISTED */))
const _hoisted_153 = { class: "col-7 px-0 flex justify-content-center" }
const _hoisted_154 = { class: "flex flex-column" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center up-to-label" }, "UP TO", -1 /* HOISTED */))
const _hoisted_156 = { class: "flex justify-content-center highest-discount" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "highest-discount-label flex flex-column justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "%"),
  /*#__PURE__*/_createElementVNode("span", null, "off")
], -1 /* HOISTED */))
const _hoisted_158 = {
  key: 9,
  id: "suggetion-div-end"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100 mt-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "px-0",
    src: "https://dr4y4dqumhrhn.cloudfront.net/service_banner_2_soma.webp"
  })
], -1 /* HOISTED */))
const _hoisted_160 = {
  key: 10,
  class: "row mx-0 w-100 mt-2 booking-info px-3"
}
const _hoisted_161 = { class: "col-12 d-flex align-items-center" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "booking-icon",
  src: "https://dr4y4dqumhrhn.cloudfront.net/outlet_dark.png"
}, null, -1 /* HOISTED */))
const _hoisted_163 = { class: "ml-4" }
const _hoisted_164 = {
  key: 11,
  class: "row mx-0 w-100 mt-2 booking-info px-3"
}
const _hoisted_165 = { class: "col-6 d-flex align-items-center" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "booking-icon",
  src: "https://dr4y4dqumhrhn.cloudfront.net/duration_dark.png"
}, null, -1 /* HOISTED */))
const _hoisted_167 = { class: "ml-4" }
const _hoisted_168 = { class: "col-6 d-flex align-items-center" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "booking-icon",
  src: "https://dr4y4dqumhrhn.cloudfront.net/pax_dark.png"
}, null, -1 /* HOISTED */))
const _hoisted_170 = { class: "ml-4" }
const _hoisted_171 = {
  key: 12,
  class: "row mx-0 w-100 mt-4 booking-info px-3 d-flex flex-column"
}
const _hoisted_172 = { class: "col-12" }
const _hoisted_173 = { class: "col-12" }
const _hoisted_174 = {
  key: 13,
  class: "row mx-0 w-100 mt-4 booking-info px-3"
}
const _hoisted_175 = { class: "col-7" }
const _hoisted_176 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_177 = {
  key: 14,
  id: "discount-info",
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_178 = { class: "col-7" }
const _hoisted_179 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_180 = {
  key: 15,
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_181 = {
  key: 0,
  class: "col-7"
}
const _hoisted_182 = {
  key: 1,
  class: "col-7"
}
const _hoisted_183 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_184 = {
  key: 16,
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, "Subtotal", -1 /* HOISTED */))
const _hoisted_186 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_187 = {
  key: 17,
  id: "previously-paid-info",
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, "Treatment Paid", -1 /* HOISTED */))
const _hoisted_189 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_190 = {
  key: 18,
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, "To Top Up", -1 /* HOISTED */))
const _hoisted_192 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_193 = {
  key: 19,
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, "Flexi Reschedule", -1 /* HOISTED */))
const _hoisted_195 = { class: "col-5 d-flex justify-content-end" }
const _hoisted_196 = {
  key: 20,
  class: "row mx-0 w-100 booking-info px-3"
}
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, "Total", -1 /* HOISTED */))
const _hoisted_198 = {
  id: "booking-total",
  class: "col-5 d-flex justify-content-end"
}
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "checkout-now",
  src: "https://dr4y4dqumhrhn.cloudfront.net/check_out_now.png"
}, null, -1 /* HOISTED */))
const _hoisted_200 = [
  _hoisted_199
]
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "page-bottom" }, null, -1 /* HOISTED */))
const _hoisted_202 = {
  key: 0,
  class: "popup-overlay"
}
const _hoisted_203 = { class: "popup d-flex flex-column align-items-center" }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/popup_v3.png" }, null, -1 /* HOISTED */))
const _hoisted_205 = {
  id: "popup-btn-row",
  class: "d-flex row mx-0 w-75"
}
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/reconsider.png" }, null, -1 /* HOISTED */))
const _hoisted_207 = [
  _hoisted_206
]
const _hoisted_208 = { class: "col-6 pl-1 pr-0" }
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dr4y4dqumhrhn.cloudfront.net/ok_lets_go.png" }, null, -1 /* HOISTED */))
const _hoisted_210 = [
  _hoisted_209
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.flexi_reschedule_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [..._hoisted_3]))
      : _createCommentVNode("v-if", true),
    ($data.banner_images.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createElementBlock("div", {
            key: $data.banner_images.length,
            id: "homeCarouse",
            class: "carousel slide",
            "data-ride": "carousel"
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.banner_images, (item, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: "javascript:;",
                  class: _normalizeClass(["carousel-item", { active: index === 0 }]),
                  "data-interval": item.type === 'video' ? 15000 : 5000
                }, [
                  (item.type === 'image')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.url,
                        class: "d-block w-100",
                        alt: item.title
                      }, null, 8 /* PROPS */, _hoisted_7))
                    : (item.type === 'video')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "video-wrapper",
                          onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleVideo && $options.toggleVideo(...args)))
                        }, [
                          _createElementVNode("video", {
                            src: item.url,
                            class: "d-block w-100",
                            autoplay: "",
                            muted: "",
                            loop: "",
                            playsinline: "",
                            ref_for: true,
                            ref: "video"
                          }, null, 8 /* PROPS */, _hoisted_8),
                          _withDirectives(_createElementVNode("div", _hoisted_9, [..._hoisted_11], 512 /* NEED_PATCH */), [
                            [_vShow, $data.showVideoPlayBtn]
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _hoisted_12
          ]))
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: ".navbar" }, [
      _createVNode(_TransitionGroup, {
        name: "toast",
        tag: "div",
        class: "toast-wrapper",
        style: _normalizeStyle({ marginTop: $data.flexi_reschedule_id ? '60px' : '5px' })
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toasts, (toast, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "toast-item",
              key: toast.id,
              innerHTML: toast.message
            }, null, 8 /* PROPS */, _hoisted_14))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["style"])
    ])),
    _createElementVNode("div", {
      id: "main",
      class: "d-flex flex-column align-items-start justify-content-start mx-auto",
      style: _normalizeStyle($options.mainStyle)
    }, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("select", {
                  id: "select-outlet",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.outlet) = $event)),
                  class: "w-100 ml-2",
                  onChange: _cache[2] || (_cache[2] = (...args) => ($options.on_outlet_change && $options.on_outlet_change(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.outlet_options, (outlet, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: outlet.name,
                      key: index
                    }, _toDisplayString(outlet.shop_full_name), 9 /* TEXT, PROPS */, _hoisted_21))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, $data.outlet]
                ])
              ])
            ])
          ])
        ]),
        ($data.outlet_info.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "waze-btn",
                        onClick: _cache[3] || (_cache[3] = $event => ($options.openWaze())),
                        width: "36",
                        height: "36",
                        fill: "#FECF6B",
                        viewBox: "0 0 24 24",
                        style: {"cursor":"pointer"}
                      }, [..._hoisted_31])),
                      _createElementVNode("div", _hoisted_32, _toDisplayString($data.outlet_info.address), 1 /* TEXT */)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", null, _toDisplayString($data.session), 1 /* TEXT */),
                    _hoisted_40
                  ])
                ]),
                ($data.session == 120)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "col-3 px-0 d-flex justify-content-center align-items-center btn-adjust-session",
                      onClick: _cache[4] || (_cache[4] = $event => ($options.adjust_session('reset')))
                    }, "−"))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "col-3 px-0 d-flex justify-content-center align-items-center btn-adjust-session",
                      onClick: _cache[5] || (_cache[5] = $event => ($options.adjust_session('add')))
                    }, "+"))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("input", {
                  id: "booking_date_datepicker",
                  type: "text",
                  ref: "datepickerInput",
                  value: $options.formatted_date,
                  readonly: ""
                }, null, 8 /* PROPS */, _hoisted_44),
                _createElementVNode("img", {
                  id: "booking-date",
                  src: "https://dr4y4dqumhrhn.cloudfront.net/calendar.png",
                  onClick: _cache[6] || (_cache[6] = (...args) => ($options.datepicker_icon_on_click && $options.datepicker_icon_on_click(...args)))
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            ($data.therapist_gender_mode == 'auto')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: "therapist-gender-outer-container",
                  onClick: _cache[7] || (_cache[7] = $event => ($options.toggle_therapist_gender_mode('specific')))
                }, [..._hoisted_48]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: "therapist-gender-outer-container",
                  onClick: _cache[8] || (_cache[8] = $event => ($options.toggle_therapist_gender_mode('auto')))
                }, [..._hoisted_50]))
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", {
                id: "pax-track-outer",
                class: "d-flex",
                style: _normalizeStyle({ transform: $data.therapist_gender_mode == 'auto' ? 'translateX(0%)' : 'translateX(-50%)' })
              }, [
                _createElementVNode("div", {
                  class: "pax-track-inner",
                  style: _normalizeStyle($data.therapist_gender_mode == 'specific' ? { paddingRight: '2%' } : {})
                }, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", {
                      class: "col-1 px-0 d-flex justify-content-center align-items-center btn-adjust-pax",
                      onClick: _cache[9] || (_cache[9] = $event => ($options.adjust_pax('minus')))
                    }, "−"),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, " X " + _toDisplayString($data.pax), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "col-1 px-0 d-flex justify-content-center align-items-center btn-adjust-pax",
                      onClick: _cache[10] || (_cache[10] = $event => ($options.adjust_pax('add')))
                    }, "+")
                  ])
                ], 4 /* STYLE */),
                _createElementVNode("div", {
                  class: "pax-track-inner",
                  style: _normalizeStyle($data.therapist_gender_mode == 'auto' ? { paddingLeft: '2%' } : {})
                }, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", {
                      class: "col-6 px-0",
                      style: _normalizeStyle($data.female_pax > 0 ? { backgroundColor: '#FE0072', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'} : {})
                    }, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", {
                          class: "col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax",
                          onClick: _cache[11] || (_cache[11] = $event => ($options.adjust_female_pax('minus')))
                        }, "−"),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, " X " + _toDisplayString($data.female_pax), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", {
                          class: "col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax",
                          onClick: _cache[12] || (_cache[12] = $event => ($options.adjust_female_pax('add')))
                        }, "+")
                      ])
                    ], 4 /* STYLE */),
                    _createElementVNode("div", {
                      id: "male-pax-container",
                      class: "col-6 px-0",
                      style: _normalizeStyle($data.male_pax > 0 ? { backgroundColor: '#012AFF', borderTopRightRadius: '8px', borderBottomRightRadius: '8px'} : {})
                    }, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", {
                          class: "col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax",
                          onClick: _cache[13] || (_cache[13] = $event => ($options.adjust_male_pax('minus')))
                        }, "−"),
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, " X " + _toDisplayString($data.male_pax), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", {
                          class: "col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax",
                          onClick: _cache[14] || (_cache[14] = $event => ($options.adjust_male_pax('add')))
                        }, "+")
                      ])
                    ], 4 /* STYLE */)
                  ])
                ], 4 /* STYLE */)
              ], 4 /* STYLE */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", {
                      class: "col-4 px-4 d-flex justify-content-center align-items-center",
                      onClick: _cache[15] || (_cache[15] = $event => ($options.adjust_therapist_rating('any'))),
                      style: _normalizeStyle($data.therapist_rating === 'any' ? { backgroundColor: '#6B00FE', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'} : {})
                    }, [
                      _hoisted_74,
                      _createTextVNode("   "),
                      _hoisted_75
                    ], 4 /* STYLE */),
                    _createElementVNode("div", {
                      id: "rating-four",
                      class: "col-4 px-4 d-flex justify-content-center align-items-center",
                      onClick: _cache[16] || (_cache[16] = $event => ($options.adjust_therapist_rating('4+'))),
                      style: _normalizeStyle($data.therapist_rating === '4+' ? { backgroundColor: '#6B00FE' } : {})
                    }, [
                      _hoisted_76,
                      _createTextVNode("   "),
                      _hoisted_77
                    ], 4 /* STYLE */),
                    _createElementVNode("div", {
                      id: "rating-five",
                      class: "col-4 px-4 d-flex justify-content-center align-items-center",
                      onClick: _cache[17] || (_cache[17] = $event => ($options.adjust_therapist_rating('5'))),
                      style: _normalizeStyle($data.therapist_rating === '5' ? { backgroundColor: '#6B00FE', borderTopRightRadius: '8px', borderBottomRightRadius: '8px' } : {})
                    }, [
                      _hoisted_78,
                      _createTextVNode("   "),
                      _hoisted_79
                    ], 4 /* STYLE */)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("button", {
            id: "btn-view-time-now",
            onClick: _cache[18] || (_cache[18] = $event => ($options.get_online_booking_available_timeslot()))
          }, [..._hoisted_82])
        ]),
        ($data.display_therapist_rating_banner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [..._hoisted_86]))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots)
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.available_timeslots, (slot, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-3 p-1",
                  key: slot.time
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["timeslot d-flex flex-column p-2", { 'timeslot-active': $data.active_slot === index, 'timeslot-unavailable': !slot.active }]),
                    onClick: $event => ($options.timeslot_on_click(slot, index))
                  }, [
                    _createElementVNode("div", _hoisted_89, _toDisplayString(slot.time.slice(0, -3)), 1 /* TEXT */),
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex justify-content-end", $options.get_discount_percentage(slot.discount)])
                    }, _toDisplayString(slot.discount) + "%", 3 /* TEXT, CLASS */),
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex justify-content-end", $options.get_discount_off(slot.discount)])
                    }, "OFF", 2 /* CLASS */)
                  ], 10 /* CLASS, PROPS */, _hoisted_88)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($data.show_floating_more_discount && $data.display_timeslots && ($data.nearby_outlet.length > 0 || $data.nearby_outlet_integrated.length > 0 || $data.next_day || $data.next_week))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              id: "floating-more-discount-row",
              class: "row mx-0 w-100 mt-4",
              onClick: _cache[19] || (_cache[19] = $event => ($options.scrollToMoreDiscount()))
            }, [..._hoisted_92]))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots && ($data.nearby_outlet.length > 0 || $data.nearby_outlet_integrated.length > 0 || $data.next_day || $data.next_week))
          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [..._hoisted_96]))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots && $data.nearby_outlet.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList($data.nearby_outlet, (n, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  (index == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, "Nearby Outlet"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["nearby-outlet-content row mx-0 py-2", {'nearby-outlet-content-no-title': index != 0}])
                  }, [
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("span", _hoisted_101, _toDisplayString(n.shop_full_name), 1 /* TEXT */),
                      _createElementVNode("button", {
                        class: "btn-view-now",
                        onClick: $event => ($options.nearby_outlet_view_now_onclick(n))
                      }, "VIEW NOW", 8 /* PROPS */, _hoisted_102)
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, _toDisplayString(n.distant), 1 /* TEXT */),
                        _hoisted_106
                      ]),
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _hoisted_109,
                          _createElementVNode("div", _hoisted_110, _toDisplayString(n.highest_discount), 1 /* TEXT */)
                        ]),
                        _hoisted_111
                      ])
                    ])
                  ], 2 /* CLASS */)
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots && $data.nearby_outlet_integrated.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList($data.nearby_outlet_integrated, (n, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  (index == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [..._hoisted_118]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["nearby-outlet-content row mx-0 py-2", {'nearby-outlet-content-no-title': index != 0}])
                  }, [
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("span", _hoisted_120, _toDisplayString(n.shop_full_name), 1 /* TEXT */),
                      _createElementVNode("button", {
                        class: "btn-view-now",
                        onClick: $event => ($options.nearby_outlet_view_now_onclick(n))
                      }, "VIEW NOW", 8 /* PROPS */, _hoisted_121)
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("div", _hoisted_124, _toDisplayString(n.distant), 1 /* TEXT */),
                        _hoisted_125
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("div", _hoisted_127, [
                          _hoisted_128,
                          _createElementVNode("div", _hoisted_129, _toDisplayString(n.highest_discount), 1 /* TEXT */)
                        ]),
                        _hoisted_130
                      ])
                    ])
                  ], 2 /* CLASS */)
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots && $data.next_day)
          ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _hoisted_133,
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _hoisted_136,
                    _createElementVNode("span", _hoisted_137, _toDisplayString($options.pretty_date($data.next_day.booking_date)), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: "btn-view-now",
                      onClick: _cache[20] || (_cache[20] = $event => ($options.next_day_next_week_view_now_onclick($data.next_day.booking_date)))
                    }, "VIEW NOW")
                  ]),
                  _createElementVNode("div", _hoisted_138, [
                    _hoisted_139,
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("div", _hoisted_141, [
                        _hoisted_142,
                        _createElementVNode("div", _hoisted_143, _toDisplayString($data.next_day.highest_discount), 1 /* TEXT */)
                      ]),
                      _hoisted_144
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots && $data.next_week)
          ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                (!$data.next_day)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, "Same Outlet | New Date"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["same-outlet-content same-outlet-content-nw row mx-0 py-2", {'nearby-outlet-content-no-title': $data.next_day}])
                }, [
                  _createElementVNode("div", _hoisted_148, [
                    _hoisted_149,
                    _createElementVNode("span", _hoisted_150, _toDisplayString($options.pretty_date($data.next_week.booking_date)), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: "btn-view-now",
                      onClick: _cache[21] || (_cache[21] = $event => ($options.next_day_next_week_view_now_onclick($data.next_week.booking_date)))
                    }, "VIEW NOW")
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _hoisted_152,
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _hoisted_155,
                        _createElementVNode("div", _hoisted_156, _toDisplayString($data.next_week.highest_discount), 1 /* TEXT */)
                      ]),
                      _hoisted_157
                    ])
                  ])
                ], 2 /* CLASS */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.display_timeslots)
          ? (_openBlock(), _createElementBlock("div", _hoisted_158))
          : _createCommentVNode("v-if", true),
        _hoisted_159,
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
              _createElementVNode("div", _hoisted_161, [
                _hoisted_162,
                _createElementVNode("div", _hoisted_163, _toDisplayString($data.outlet_info.shop_full_name), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
              _createElementVNode("div", _hoisted_165, [
                _hoisted_166,
                _createElementVNode("div", _hoisted_167, _toDisplayString($data.session) + " mins", 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_168, [
                _hoisted_169,
                _createElementVNode("div", _hoisted_170, _toDisplayString(this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax) + " pax", 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
              _createElementVNode("div", _hoisted_172, _toDisplayString($options.formatted_date), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_173, _toDisplayString($options.format_checkout_time()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
              _createElementVNode("div", _hoisted_175, _toDisplayString($options.get_session_price()) + " x " + _toDisplayString(this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax) + " Pax", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_176, _toDisplayString($options.get_total_before_discount()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined && this.available_timeslots[this.active_slot].discount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, _toDisplayString(this.available_timeslots[this.active_slot].discount) + "% off", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_179, "- " + _toDisplayString($options.get_total_discount()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
              ($data.has_sst)
                ? (_openBlock(), _createElementBlock("div", _hoisted_181, "SST 8%"))
                : (_openBlock(), _createElementBlock("div", _hoisted_182, "SST 0%")),
              _createElementVNode("div", _hoisted_183, _toDisplayString($options.get_total_tax_without_flexi_reschedule_fee()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined && $data.flexi_reschedule_id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
              _hoisted_185,
              _createElementVNode("div", _hoisted_186, _toDisplayString($options.get_subtotal()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined && $data.flexi_reschedule_id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
              _hoisted_188,
              _createElementVNode("div", _hoisted_189, "- " + _toDisplayString($options.get_previously_paid()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined && $data.flexi_reschedule_id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
              _hoisted_191,
              _createElementVNode("div", _hoisted_192, _toDisplayString($options.get_to_top_up()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined && $data.flexi_reschedule_id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
              _hoisted_194,
              _createElementVNode("div", _hoisted_195, _toDisplayString($options.get_total_flexi_reschedule_fee()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
              _hoisted_197,
              _createElementVNode("div", _hoisted_198, _toDisplayString($options.get_total_after_discount_and_tax()), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.active_slot !== undefined)
          ? (_openBlock(), _createElementBlock("div", {
              key: 21,
              class: "row mx-0 w-100 mt-2 mb-16",
              onClick: _cache[22] || (_cache[22] = $event => ($options.checkout_now_onclick()))
            }, [..._hoisted_200]))
          : _createCommentVNode("v-if", true),
        _hoisted_201
      ]),
      ($data.display_checkout_confirmation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
            _createElementVNode("div", _hoisted_203, [
              _hoisted_204,
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("div", {
                  class: "col-6 pl-0 pr-1 popup-btn",
                  onClick: _cache[23] || (_cache[23] = $event => ($options.reconsider_onclick()))
                }, [..._hoisted_207]),
                _createElementVNode("div", _hoisted_208, [
                  _createElementVNode("button", {
                    id: "btn-ok-lets-go",
                    onClick: _cache[24] || (_cache[24] = $event => ($options.ok_lets_go_onclick()))
                  }, [..._hoisted_210])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}